<template>
  <a-modal
    class="data-dialog"
    title="查看详情"
    width="1000px"
    v-model:visible="visible"
    :footer="false"
  >
    <a-form class="upload-detail-form" layout="inline">
      <a-form-item label="名称">
        <span>{{ currentItem.uploadNote }}</span>
      </a-form-item>
      <a-form-item label="上传ID">
        <span>{{ currentItem.id }}</span>
      </a-form-item>
      <a-form-item label="标注类型">
        <span>{{ getDataTypeName(currentItem.itemTypeId) }}</span>
      </a-form-item>
      <a-form-item label="上传人">
        <span>{{ getUserName(currentItem.createUserId) }}</span>
      </a-form-item>
      <a-form-item label="上传时间">
        <span>{{ getDateTime(currentItem.createTime) }}</span>
      </a-form-item>
      <a-form-item label="团队">
        <span>{{ getTeamName(currentItem.teamId) }}</span>
      </a-form-item>
      <br>
      <a-form-item label="上传文件">
        <span>{{ currentItem.location }}</span>
      </a-form-item>
      <a-form-item label="处理状态">
        <span>{{ currentItem.state }}</span>
      </a-form-item>
      <a-form-item label="tag标签">
        <span>{{ getTagNames(currentItem.tagIdList) }}</span>
      </a-form-item>
      <a-form-item label="数据属性">
        <div>
          <p v-for="(info, index) in valueAndParent" :key="index">
            {{ info.parentName }}：{{ info.children.map(c => c.chineseInstructions).join('，') }}
          </p>
        </div>
      </a-form-item>
    </a-form>
    <div class="ctrl-wrap">
      <a-button type="primary" @click="visible = false">返回</a-button>
    </div>
  </a-modal>
</template>
<script>
import { getItemValueById, getItemValueParent } from '@/api/dataAttr'
import { getDateTime, getTeamName, getDataTypeName, getUserName } from '@/filters'
export default {
  props: {
    currentItem: {
      type: Object,
      default: () => {}
    },
    allTags: {
      type: Array,
      default: () => []
    },
    dataAttrData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      getDataTypeName,
      visible: false,
      attrValue: [],
      valueAndParent: []
    }
  },
  methods: {
    getDateTime,
    getTeamName,
    getUserName,
    open () {
      this.visible = true
      this.$nextTick(() => {
        console.log(this.currentItem)
        if (this.currentItem && this.currentItem.itemValueIdList) {
          this.attrValue = this.currentItem.itemValueIdList.split(',')
        } else {
          this.attrValue = []
        }
        this.getValueAndParent()
      })
    },
    async getValueAndParent () {
      this.valueAndParent = []
      for (const id of this.attrValue) {
        const info = await this.getAttrKeyValue(id)
        if (!info) continue
        const exist = this.valueAndParent.find(i => i.parentId === info.parent.id)
        if (exist) {
          exist.children.push(info.itemValue)
        } else {
          this.valueAndParent.push({
            parentId: info.parent.id,
            parentName: info.parent.chineseInstructions,
            children: [info.itemValue]
          })
        }
      }
    },
    async getAttrKeyValue (itemValueId) {
      const res1 = await getItemValueById(itemValueId)
      const itemValue = res1.data.map.data.rows[0]
      if (!itemValue) return
      const res2 = await getItemValueParent(itemValue)
      const parent = res2.data.map.data.rows[0]
      if (!parent) return
      return {
        itemValue, parent
      }
      // get itemValue name
      // get parent name
    },
    getTagNames (str) {
      if (!str) return ''
      const arr = str.split(',')
      const nameArr = arr.map(id => {
        const found = this.allTags.find(t => t.id === id)
        return found.chineseInstructions
      })
      return nameArr.join(',')
    }
  }
}

</script>
<style lang="less">
.upload-detail-form {
.ant-form-item {
  margin: 0 0 20px; width: 50%;
}
}
</style>
